export const localeText= {
      // Filtreleme menüsü
      page: 'Sayfa',
      more: 'Daha Fazla',
      to: 'ile',
      of: 'arası',
      next: 'Sonraki',
      last: 'Son',
      first: 'İlk',
      previous: 'Önceki',
      loadingOoo: 'Yükleniyor...',

      // Filtre araçları
      selectAll: 'Tümünü Seç',
      searchOoo: 'Ara...',
      blanks: 'Boş',
      noMatches: 'Eşleşme Bulunamadı',

      // Filtre butonları
      apply: 'Uygula',
      reset: 'Sıfırla',
      clear: 'Temizle',
      cancel: 'İptal',

      // Filtre başlıkları
      equals: 'Eşittir',
      notEqual: 'Eşit Değil',
      lessThan: 'Küçüktür',
      greaterThan: 'Büyüktür',
      lessThanOrEqual: 'Küçük Eşittir',
      greaterThanOrEqual: 'Büyük Eşittir',
      inRange: 'Aralıkta',
      contains: 'İçerir',
      notContains: 'İçermez',
      startsWith: 'İle Başlar',
      endsWith: 'İle Biter',
      notBlank:'Dolu',
      blank:'Boş',

      // Tarih filtresi için çeviriler
      dateFormatOoo: 'dd.MM.yyyy',
      dateFrom: 'Başlangıç Tarihi',
      dateTo: 'Bitiş Tarihi',
      filterOoo: 'Filtrele...',

      // AG Grid menü seçenekleri
      columns: 'Sütunlar',
      filters: 'Filtreler',
      valueColumns: 'Değer Sütunları',
      pivotColumns: 'Pivot Sütunları',
      rowGroupColumns: 'Satır Grup Sütunları',
      filterColumnsEmptyMessage: 'Sürükleyip bırakın (boş)',

      // Filtre seçenekleri
      and: 'VE',
      or: 'VEYA',

      // Diğer
      noRowsToShow: 'Gösterilecek Veri Yok',
      enabled: 'Etkin',

      // Menü butonları
      pinColumn: 'Sütunu Sabitle',
      pinLeft: 'Sola Sabitle',
      pinRight: 'Sağa Sabitle',
      noPin: 'Sabitlemeyi Kaldır',
      valueAggregation: 'Değer Toplamları',
      autosizeThiscolumn: 'Bu Sütunu Otomatik Boyutlandır',
      autosizeAllColumns: 'Tüm Sütunları Otomatik Boyutlandır',
      groupBy: 'Grupla',
      ungroupBy: 'Gruplamayı Kaldır',

      // Sütun menü butonları
      resetColumns: 'Sütunları Sıfırla',
      expandAll: 'Tümünü Genişlet',
      collapseAll: 'Tümünü Daralt',
      copy: 'Kopyala',
      ctrlC: 'Ctrl+C',
      copyWithHeaders: 'Başlıklarla Kopyala',
      paste: 'Yapıştır',
      ctrlV: 'Ctrl+V',
      export: 'Dışa Aktar',
      csvExport: 'CSV Dışa Aktar',
      excelExport: 'Excel Dışa Aktar (.xlsx)',
      excelXmlExport: 'Excel Dışa Aktar (.xml)',

      // Gezinme ve seçim
      search: 'Ara',
      true: 'Doğru',
      false: 'Yanlış',

      // Tarih filtresi
      empty: 'Boş',
      notEmpty: 'Boş Değil',
      custom: 'Özel',
      before: 'Önce',
      after: 'Sonra',

      // Tümünü temizle
      clearFilter: 'Filtreyi Temizle',
      clearSort: 'Sıralamayı Temizle',

      // Satır yükleme
      loadingRows: 'Satırlar Yükleniyor...'
    }